import React from 'react';
import { observer } from 'mobx-react-lite';
import { AdminPageLayout } from '../../../components/uiComponents/UIComponents';
import { ActionCards } from './actionCards';

export const DashboardPage: React.FC = observer(() => {
    return <AdminPageLayout content={<ActionCards />} />;
});
